export default IconLambda => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-lambda" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M6 20l6.5 -9" />
  <path d="M19 20c-6 0 -6 -16 -12 -16" />
</svg>`;